import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/clipboard-check.svg'


const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "payment-status" }
const _hoisted_3 = { class: "payment-status__content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "payment-status__img"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "payment-status__heading" }, "Booking was successful!", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "payment-status__message" }, " Your booking was successful. You will receive an email confirmation with all your details. ", -1)
const _hoisted_7 = { class: "payment-status__btns-wrap" }

import { useRoute } from 'vue-router'
import { useBookNowPayByCard } from '@/store/book-now'
import { useUser } from '@/store/user'
import dayjs from 'dayjs'
import { computed, onMounted, ref } from 'vue';
import { Booking } from '@/models/book-now'
import { useIntervalFn } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'BookPaymentSuccessful',
  setup(__props) {

const route = useRoute()

const booking = ref<Booking>()
const { hasAuthToken } = useUser()
const { getBooking, loginUserByPaymentIntent } = useBookNowPayByCard(route.params.id as unknown as number, route.params.hash as string)

const viewBookingLink = computed(() => {
  if (!hasAuthToken.value) {
    return false
  }

  let startDate;
  if (booking.value) {
    const dateJs = dayjs(booking.value.jobStart);
    if (dateJs.isValid()) {
      startDate = dateJs.format("YYYY-MM-DD");
    }
  }

  const query = {
    startDate,
    endDate: startDate,
  };

  return { name: 'bookings', query }
})

const checkLoginToken = () => {
  const paymentIntent = route.query.intentId as string
  if (paymentIntent) {
    const { pause } = useIntervalFn(() => {
      if (hasAuthToken.value) {
        pause()
      } else {
        loginUserByPaymentIntent(paymentIntent)
      }
    }, 2000)
  }
}

onMounted(async () => {
  booking.value = await getBooking()
  checkLoginToken()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_unref(viewBookingLink))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "btn btn-block",
                  to: _unref(viewBookingLink)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" View booking ")
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: { name: 'book' },
              type: "submit",
              class: "btn btn-block btn-secondary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" make another booking ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})